import React, { useState } from 'react';
import './bookacall.css';

function BookConsultationForm() {
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();

    // Prepare the data to be sent via WhatsApp
    const formData = {
      name,
      location,
      email,
      phoneNumber,
      selectedDate,
      selectedTime
    };

    // Format the message
    const message = `📅 Consultation Request:\n\nName: ${name}\nLocation: ${location}\nEmail: ${email}\nPhone Number: ${phoneNumber}\nPreferred Date: ${selectedDate}\nPreferred Time: ${selectedTime}`;

    // Replace this with your WhatsApp number
    const whatsappNumber = '+923095921582';

    // Generate WhatsApp link
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    // Redirect to WhatsApp
    window.location.href = whatsappLink;

    // Set form submission status to true
    setIsSubmitted(true);
  };

  return (
    <div className="consultation-form">
      {isSubmitted ? (
        <div className="success-message">Thank you! Your consultation request has been submitted.</div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="location">Location:</label>
            <input
              type="text"
              id="location"
              value={location}
              onChange={e => setLocation(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number:</label>
            <input
              type="tel"
              id="phoneNumber"
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              placeholder="Enter phone number"
              required
            />
          </div>
          <div className="calendar-group">
            <label htmlFor="date">Preferred Date:</label>
            <input
              type="date"
              id="date"
              value={selectedDate}
              onChange={e => setSelectedDate(e.target.value)}
              required
            />
            <label htmlFor="time">Preferred Time:</label>
            <input
              type="time"
              id="time"
              value={selectedTime}
              onChange={e => setSelectedTime(e.target.value)}
              required
            />
          </div>
          <button type="submit">Book A Call</button>
        </form>
      )}
    </div>
  );
}

export default BookConsultationForm;